import type { ReactNode } from 'react';

export function Stat({ label, value, hint }: { label: string; value: ReactNode; hint?: string }) {
  return (
    <div title={hint}>
      <div className="font-display text-[10px] font-bold uppercase tracking-[0.16em] text-faint">
        {label}
      </div>
      <div className="font-mono text-sm tabular-nums text-text">{value}</div>
    </div>
  );
}
